import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import FetchSavedCreds from "./FetchSavedCreds";
import {
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Box,
  Typography,
  Button
} from "@material-ui/core";
import AuthenticateModal from "./AuthenticateModal";
import axios from "axios";
import swal from "sweetalert";
import { config } from "../../../constants";

const BankModal = ({ title, img, bankData, slug, refreshBankData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
 const [selectedBankSlug, setSelectedBankSlug] = useState("");

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option) => {
    setModalContent(option);
    if (option === "Manage Credentials") {
      setSelectedBankSlug(title.toLowerCase()); 
    } 
    else if (option === "Authenticate") { 
        setSelectedBankSlug(title.toLowerCase()); 
    }
    setOpenModal(true);
    handleMenuClose();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalContent("");
  };

  const handleDeleteBank = async () => {
    const result = await swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this bank connection?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!result) {
      return;
    }

    try {
      // Determine the correct API endpoint based on bank slug
      let deleteEndpoint = "";
      if (slug === "standard") {
        deleteEndpoint = `${config.BANK_API_URL}/api/standardbank/delete/${bankData.profile}`;
      } else if (slug === "fnb") {
        deleteEndpoint = `${config.BANK_API_URL}/api/fnbBank/delete/${bankData.profile}`;
      } else if (slug === "nedbank") {
        deleteEndpoint = `${config.BANK_API_URL}/api/nedbank/delete/${bankData.profile}`;
      }

      if (!deleteEndpoint) {
        throw new Error("Invalid bank type");
      }

      // Show loading
      swal({
        title: "Deleting...",
        text: "Please wait while we delete the bank connection.",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      // Make DELETE API call
      await axios.delete(deleteEndpoint, {
        headers: {
          'X-Tenant-ID': config.TENANT_ID
        }
      });

      // Close loading and show success message
      await swal({
        title: "Success!",
        text: "Bank connection deleted successfully",
        icon: "success",
        button: "OK",
      });

      // Refresh bank data to update UI
      if (refreshBankData) {
        await refreshBankData();
      }
    } catch (error) {
      console.error("Error deleting bank connection:", error);
      await swal({
        title: "Error",
        text: error.response?.data?.message || "Failed to delete bank connection. Please try again.",
        icon: "error",
        button: "OK",
      });
    }
  };

  return (
    <>
      <Row className="mt-3 align-items-center">
        <Col md={4}>{title}</Col>
        <Col md={5} className="d-flex align-items-center">
          <div className="w-50 text-center heightFix">
            <img src={img} alt="img" style={{ height: "50px", objectFit: "contain" }} />
          </div>
          <IconButton onClick={handleMenuOpen}>
            <span style={{ fontSize: "18px", fontWeight: "bold", writingMode: "vertical-rl", transform: "rotate(180deg)" }}>•••</span>
        </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleOptionClick("Manage Credentials")}>
            <span style={{ marginRight: 8 }}>✏️</span>
            Manage Credentials
            </MenuItem>

            <MenuItem onClick={() => handleOptionClick("Authenticate")}>
            <span style={{ marginRight: 8 }}>🔓</span>
             Authenticate
            </MenuItem>

            <MenuItem
              onClick={() => {
                handleMenuClose();
                handleDeleteBank();
              }}
              style={{ color: "#d32f2f" }}
            >
            <span style={{ marginRight: 8 }}>🗑️</span>
             Delete Connection
            </MenuItem>
          </Menu>
        </Col>
      </Row>

     {modalContent === "Manage Credentials" && (
        <FetchSavedCreds
          open={openModal}
          handleClose={handleCloseModal}
          bankSlug={bankData.bankName}
        />
      )}

      {
        modalContent === "Authenticate" && (
            <AuthenticateModal
            open={openModal}
            onClose={handleCloseModal}
            bankName={bankData.bankName}
            profileId={bankData.profile}
            />
        )
      }

    </>
  );
};

export default BankModal;
